import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiExternalLink } from 'react-icons/fi';

const Hero = () => {
  const { t } = useLanguage();
  const portalUrl = "https://albertorodriguez.mytaxportal.online/";

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center pt-20 overflow-hidden">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat transition-transform duration-[10s] scale-110 motion-safe:animate-slow-zoom" 
        style={{ backgroundImage: 'url("https://images.unsplash.com/photo-1556761175-5973dc0f32d7?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80")' }}
      >
        <div className="absolute inset-0 bg-blue-900/80 mix-blend-multiply"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center pt-10">
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="text-4xl sm:text-5xl md:text-7xl font-extrabold text-white tracking-tight mb-8 leading-[1.1]">
            {t('hero.title').split(' ').map((word, i) => (
              <span key={i} className={
                word.toLowerCase().includes('inmigración') || 
                word.toLowerCase().includes('finanzas') || 
                word.toLowerCase().includes('immigration') || 
                word.toLowerCase().includes('finances') ? 'text-blue-400' : ''
              }>
                {word}{' '}
              </span>
            ))}
          </h1>
          <p className="mt-4 text-xl sm:text-2xl text-gray-200 max-w-3xl mx-auto mb-12 font-light leading-relaxed">
            {t('hero.subtitle')}
          </p>
          <div className="flex flex-col sm:flex-row justify-center items-center gap-4">
            <a 
              href="#contact" 
              className="w-full sm:w-auto px-10 py-5 bg-blue-600 text-white rounded-xl font-bold text-lg hover:bg-blue-700 transition-all shadow-xl hover:shadow-2xl transform hover:-translate-y-1 active:scale-95"
            >
              {t('hero.cta1')}
            </a>
            <a 
              href={portalUrl} 
              target="_blank"
              rel="noopener noreferrer"
              className="w-full sm:w-auto px-10 py-5 bg-white text-blue-900 rounded-xl font-bold text-lg hover:bg-gray-100 transition-all shadow-xl hover:shadow-2xl transform hover:-translate-y-1 active:scale-95 flex items-center justify-center gap-2"
            >
              <span>{t('hero.portalCta')}</span>
              <SafeIcon icon={FiExternalLink} className="w-5 h-5" />
            </a>
          </div>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce opacity-50">
        <div className="w-[30px] h-[50px] rounded-full border-2 border-white/50 flex justify-center p-2">
          <div className="w-1 h-3 bg-white rounded-full"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;